
<template>
<div>
  <!-- Busqueda Return -->
  <v-row>
    <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="quotes.length > 0">
      <span class="right"><b>{{ quotes.length }}</b> registro(s) encontrados <br></span>
      <br><br>
        <!-- Tabla Salida -->
        <template>
          <!-- height="700px" -->
          <v-simple-table
            fixed-header
            dense
          >
            <template v-slot:default>
              <thead>
                <tr><th class="text-left" v-for="thead in theader" :key="thead.id">{{thead.text}}</th></tr>
              </thead>
              <tbody>
                <!-- v-for="row in subfamilies" -->
                <tr v-for="(row,index) of quotes" :key="row.id" >              
                  <td>     
                    <v-btn icon v-on:click="editRow = row.id">
                      <v-icon>edit</v-icon>
                    </v-btn>        
                    <v-btn
                                    v-if="row.notes != null && row.notes != ''"
                                          color="red lighten-2"
                                          icon
                                          @click="getNote(row.notes)" 
                                        >
                                        <v-icon>note</v-icon>
                    </v-btn>                 
                  </td>      
                  <td>
                    {{ index+1 }} - {{ row.id }}
                    <div v-if="editRow === row.id">
                      <!-- <input v-on:keyup.13="updateRow(row)" placeholder="Sucursal id" v-model="row.branch_id" /> -->          
                      <v-text-field
                                  v-model="row.name"
                                  v-on:keyup.13="updateRow(row)"
                                  label="Nombre"
                      />          
                      <v-text-field
                          v-model="row.label"
                          v-on:keyup.13="updateRow(row)"
                          label="Etiqueta"
                      />                                
                      <v-text-field
                                  v-model="row.notes"
                                  v-on:keyup.13="updateRow(row)"
                                  label="Notas"
                      />                         
                      <v-btn v-on:click="updateRow(row)" class="green">Actualizar</v-btn>
                      <v-btn v-on:click="editRow=false" class="deep-dark">cerrar</v-btn>
                    </div>        
                  </td>    
                  <!-- <td>{{row.branchname}}  </td> -->
                  <td>{{row.name}} </td>   
                  <td>{{row.label}} </td>               
                  <td>{{formatDate(row.created_at)}}</td>     
                  <td>{{formatDate(row.updated_at)}}</td>     
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>
        <!-- FIN table -->                                    
    </v-col>
    <v-col cols=12 sm=12 md=12 lg=12
      v-else
    >
      <v-alert
          dense
          outlined
          type="error"
      >
          No hay registros encontrados
      </v-alert>
    </v-col>
  </v-row>
  <!-- FIN Busqueda SalesOrder -->  

    <!-- DIALOG NOTAS -->
      <div class="text-center">
            <v-dialog
              v-model="dialogNotes"
              width="30%"
            >
              <v-card>
                <v-card-title class="headline grey lighten-2">
                  Notas
                </v-card-title>
                <v-card-text class="my-5">
                  {{notes}}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    text
                    @click="dialogNotes = false"
                  >
                    Cerrar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
      </div>
    <!-- FIN DIALOG NOTAS -->

</div>
</template>

<script>
import{ mapMutations,mapState } from "vuex";
// import{ mapMutations,mapState,mapGetters } from "vuex";
// import baseApi from '@/services/baseApi';
import icheckApi from '@/services/icheckApi';

// import router from '@/router';
import Dayjs from 'dayjs';
import es from "dayjs/locale/es"




export default {
  props:{
    quotes:{
      type:Object,
      required:true
    }
  },
  computed:{
    //'products'
      ...mapState(['customers','currentUser'])
  },
  components: {    

  },
  methods:{
    ...mapMutations(["showLoading","hiddenLoading"]), 
    formatDate(dateString) {
            Dayjs.locale(es)
            const date = Dayjs(dateString);
            return date.format('dddd MMMM D, YYYY')
    },   
    url: function (href){
        return 'articleswarehouse?warehouseid='+ href
    },     
    getNote(note){
      // console.log('Producto ID:'+ProductID);
      this.notes=note;
      // alert(this.productid);
      this.dialogNotes =true;  
    },  
    updateRow(row) {      
      try{        
          this.showLoading({titulo:"Accediendo información",color:"warning"})        
          //var url="https://www.cloudbits.org.mx/fw/lumen/check/precios/update/"+ row.id;
          // const baseURL2=`https://www.cloudbits.org.mx/fw/lumen/check/cotizaciones/update/${row.id}`;
          // const config = {
          //   data: JSON.stringify(row),
          //   method: "post", //you can set what request you want to be
          //   url:baseURL2,
          //   timeout: 10000,
          //   headers: {
          //     'Access-Control-Allow-Origin': '*',
          //     'Access-Control-Allow-Headers': '*',
          //     "Content-Type": "application/json",
          //     "Api-Token": 'gRTjsp26Gu27KVq0oZco24q3TmEayjM0QFlIrjm5WHZOBWCnK2GvAA4FYaxr',
          //   }
          // }
          // let datos=this.axios(config)    
          let datos = icheckApi().post(`/almacenes/update/${row.id}`,JSON.stringify(row));                                                                                                    
          console.log(datos);
        }catch(error){
          console.log(error);
        }  finally{
          this.hiddenLoading()
          this.$swal("Genial!", "Se actualizó la información", "success");
        } 
    },
    
  },
  destroyed() {
    console.log("Destruido QuoteItem");
  },
  mounted(){
    console.log("Montado QuoteItem");
    // if (this.productid>0) {
      this.getCustomer()
    // }
  },
  data(){
    return{
      attribute: {sword: '',limit: 500},
      dialogNotes:false,
      editRow:null,
      editRowProjectID:null,
      customer_id:77,
      employee_id:'',      
      notes:'',
      itemsStatus: [
          'Proceso',
          'Cancelada',
          'Pagado',
          'Contratado',
      ],    
      theader: [
          { text: 'Accion', value: 'customername' },
          { text: '#', value: 'customername' },
          { text: 'Nombre', value: 'iva_quote' },
          { text: 'Etiqueta', value: 'total_quote' },          
          { text: 'Registro', value: 'iva_quote' },
          { text: 'Actualizacion', value: 'iva_quote' },
      ],
    }
  }
}
</script>